/**
 * Convert a 2-letter ISO 3166-1 alpha-2 country code (e.g. "IT") into
 * the corresponding regional-indicator emoji flag ("🇮🇹").
 *
 * Returns an empty string for invalid / unknown / falsy inputs so the
 * caller can do `{flag && <span>{flag}</span>}` without surprises.
 */
export function countryCodeToFlag(code) {
  if (!code || typeof code !== 'string') return '';
  const cc = code.trim().toUpperCase();
  if (cc.length !== 2 || !/^[A-Z]{2}$/.test(cc)) return '';
  // Each letter is offset to its regional-indicator counterpart.
  // 0x1F1E6 is the codepoint for 🇦.
  const A = 0x1F1E6;
  const codepoints = [cc.charCodeAt(0) - 65 + A, cc.charCodeAt(1) - 65 + A];
  return String.fromCodePoint(...codepoints);
}
